import rpc from '@square/dashboard-utilities/clients/rpc';
import { JpSmirfService } from '@square/dashboard-protos/models/squareup/jpsmirf/externalservice';
export default JpSmirfService.create(rpc());